export { ZoomImage } from './ZoomImage';
